import { BaseDriver } from '@wix/wix-ui-test-utils/driver-factory';

export interface EditableRowDriver extends BaseDriver {
  isInputFocused: () => boolean;
  clickApprove: () => void;
  clickCancel: () => void;
  isApproveDisabled: () => boolean;
  getText: () => string;
  setText: (text: string) => void;
  keyDown: (keyCode: number) => void;
}
